<script setup>
import { computed } from 'vue';
import { useFieldErrors } from '@/composables/ruleEngine/useFieldErrors';

const props = defineProps({
    modelValue: { type: Object, default: () => ({}) },
    errors: { type: [Array, Object], default: () => ({}) },
});

const emit = defineEmits(['update:modelValue', 'touched']);

const model = computed({
    get: () => props.modelValue || {},
    set: (val) => emit('update:modelValue', val),
});

const { errorsFor } = useFieldErrors(props);

const setNumber = (key, value) => {
    emit('touched');
    let finalValue = null;

    if (value !== '' && value !== null) {
        finalValue = Number(value);
    }

    model.value = {
        ...model.value,
        [key]: finalValue,
    };
};

const minAmount = computed({
    get: () => model.value.min_amount ?? '',
    set: (val) => setNumber('min_amount', val),
});

const maxAmount = computed({
    get: () => model.value.max_amount ?? '',
    set: (val) => setNumber('max_amount', val),
});
</script>

<template>
<div class="grid md:grid-cols-2 gap-4">
    <StyledInput
        v-model="minAmount"
        :label="$t('label.amount_to_finance_minimum')"
        name="min_amount"
        type="number"
        :error-messages="errorsFor('min_amount')" />

    <StyledInput
        v-model="maxAmount"
        :label="$t('label.amount_to_finance_maximum')"
        name="max_amount"
        type="number"
        :error-messages="errorsFor('max_amount')" />
</div>
</template>
